define('GameDayCore/GDModel/ValueObjects/Plays/ScoringPlays',['require','exports','module','../ValueObjectFactory','./AtBat','../../../GDUtil/dataMapping/NumberWithOrdinal','gameday-resource-path/gameday-resource-path'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
		AtBat = require('./AtBat'),
		Ordinal = require("../../../GDUtil/dataMapping/NumberWithOrdinal"),
        resourcePath = require( 'gameday-resource-path/gameday-resource-path' ),
		top_or_not = {
			'N' : 'bottom',
			'Y' : 'top'
		},
		home_or_away={
			'N' : 'home',
			'Y' : 'away'
		};

	VO.create(ScoringPlays);

	function ScoringPlays($data) {
		var vo = VO.ensureVO(this, ScoringPlays),
			data = $data,
			scores = data.score,
			innings = sortToInnings(Array.isArray(scores) ? scores : [scores]);
	
		vo.innings = innings.filter(Boolean);
		vo.away_team = data.away_team;
		vo.home_team = data.home_team;
	}

	function inning_half(is_top) {
		return {
			atbats	:[],
			has_atbats : false,
			top_or_bottom : top_or_not[is_top],
			home_or_away  : home_or_away[is_top]			
		}
	}
	function sortToInnings(scores) {
		var i = 0,
			len = scores.length,
			inn,
			half,
			is_top,
			innings = [];

		for(i; i < len; i++) {
			if(scores[i]) {
				inn =~~ scores[i].inn;
				is_top = scores[i].top_inning;
				if(!innings[inn]) {
					innings[inn] = {
						num     		: inn,
                        inning          : inn,
						numWithOrdinal 	: Ordinal(inn),
						top 			: inning_half('Y'),
						bottom 			: inning_half('N')
					};
					innings[inn].halves = [innings[inn].top,innings[inn].bottom];
				}
				innings[inn][top_or_not[is_top]].hasAtBats = true;
				innings[inn][top_or_not[is_top]].atbats.push(parsePlay(scores[i]));
			}
		}
		return innings;
	}

	function parsePlay(score) {
        var i = 0,
         	a = 0,
         	aLen,
         	actions,
         	scoringPlay = {};

            scoringPlay.top_or_bottom = top_or_not[score.top_inning];
            scoringPlay.home_or_away = home_or_away[score.top_inning];
            scoringPlay.homeScore = score.home;
            scoringPlay.awayScore = score.away;

            if(score.action) {
                actions = [].concat(score.action);
                aLen = actions.length;
                for(a = 0; a < aLen; a++){
                    if(actions[a].score === "T"){
                        scoringPlay.des = actions[a].des;
                        scoringPlay.event = actions[a].event
                        scoringPlay.player = actions[a].player;
                        scoringPlay.pitcher = actions[a].pitcher;
                        // Actions don't have AtBat objects.. they need a mugshot helper
                        scoringPlay.batterMug = function(){
			                return resourcePath.get('mugshot',{ pid : this.player});
			            };
                    }
                }
            }
            if(score.atbat){
                actions = [].concat(score.atbat);
                aLen = actions.length;
                for(a = 0; a < aLen; a++){
                    if(actions[a].score === "T"){
	                	var atBat = new AtBat(actions[a], score.inn);
	                	scoringPlay.num = atBat.num;
	                	if(!scoringPlay.des || !scoringPlay.event){
	                        scoringPlay.des = scoringPlay.message || actions[a].des;
	                        scoringPlay.event = scoringPlay.event || actions[a].event;
	                        scoringPlay.player = scoringPlay.player || actions[a].batter;
	                        scoringPlay.pitcher = scoringPlay.pitcher || actions[a].pitcher;
	                        scoringPlay.b = atBat.b;
	                        scoringPlay.o = atBat.o;
	                        scoringPlay.s = atBat.s;
	                        scoringPlay.isPlay = atBat.isPlay;
	                        scoringPlay.pitches = atBat.pitches;
	                        // Template isn't using AtBat object, so needs helper on scoringPlay object
	                        scoringPlay.batterMug = function(){
				                return resourcePath.get('mugshot',{ pid : this.player});
				            };
	                    }
                    }
                }
            }

            scoringPlay.des=scoringPlay.des || score.pbp;

		return scoringPlay;
	}

	return ScoringPlays;
});
